import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18px",
  height: "18px",
  viewBox: "0 0 18 18",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z",
  "stroke-dasharray": "60"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("polyline", {
  points: "1 9 7 14 15 4",
  "stroke-dasharray": "22",
  "stroke-dashoffset": "66"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }